import gql from 'graphql-tag';
import FieldsCreditBundle from 'graphql/fields/FieldsCreditBundle';

export default gql(`
	query credit_bundle( $guid: String! ) {
		credit_bundle( guid: $guid ) {
			${FieldsCreditBundle}

			timeslot_kind {
				guid
			}
		}
	}
`);

